document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 1024) {
    const productShadowElements = document.querySelectorAll('.product-shadow');

    productShadowElements.forEach(function (productShadowElement) {
      const cardMediaElement = productShadowElement.querySelector('.card__media');
      const cardActionsElement = productShadowElement.querySelector('.card__actions');
      const imgSliderButtons = productShadowElement.querySelectorAll('.product-img-slider');
      let currentIndex = 0;

      if (cardMediaElement) {
        const images = cardMediaElement.querySelectorAll('img');
        const totalImages = images.length;

        function updateImage(index) {
          images.forEach((img, i) => {
            img.style.display = i === index ? 'block' : 'none';
          });
        }

        if (totalImages <= 1) {
          imgSliderButtons.forEach(button => button.style.display = 'none');
        }

        productShadowElement.addEventListener('mouseover', function () {
          cardActionsElement.classList.add('card__media--hover');
          if (totalImages > 1) {
            imgSliderButtons.forEach(button => button.style.display = 'block');
          }
        });

        productShadowElement.addEventListener('mouseout', function () {
          cardActionsElement.classList.remove('card__media--hover');
          imgSliderButtons.forEach(button => button.style.display = 'none');
        });

        imgSliderButtons.forEach(button => {
          button.addEventListener('click', function (event) {
            if (event.target.closest('.product-slider-left')) {
              currentIndex = (currentIndex > 0) ? currentIndex - 1 : totalImages - 1;
            } else {
              currentIndex = (currentIndex < totalImages - 1) ? currentIndex + 1 : 0;
            }
            updateImage(currentIndex);
          });
        });

        updateImage(currentIndex);
      }
    });
  }
});